export const WGPT_BOARD_LIST_CARDS_QUERY_LIMIT = 15;
